module.exports = __webpack_public_path__ + "static/media/1008280.ce579c35.png";